<template>
  <div>
    <headerNav :title="ztitle" />

   <van-radio-group v-model="selectLevelId" >
      
        <div class="group-main"  v-for="(item,index) in memberlevels" :key="index" > 
            <div class="group-main-conf">
              <div class="group-main-conf-pic">
                <img :src="abp.setUrl(item.imgPath)" />
              </div>
              <div>品牌:群婴汇</div>
              <div>{{'级别:'+item.name}}</div>
              <div class="group-main-conf-radio">
                <van-radio :checked-color="$abctheme.basecolor" :name="item.id" :icon-size="40" :value="item.id"/>
              </div>
            </div>
        </div>
      
    </van-radio-group>

    <div style="text-align:center">
      <van-button type="info" :color="$abctheme.basecolor" round style="width:300px" @click="generate">生成</van-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      selectLevelId: 0,
      memberlevels: [],
      registMethod: 0,
      ztitle:'发展下级'
    };
  },
  created() {
    this.registMethod = this.$route.query.registMethod;
    if (this.registMethod == 0) {
       this.ztitle="发展下级";
      this.ajax
        .post("/api/services/app/PhoneUser/QueryMySubordinateLevel")
        .then((x) => {
          this.memberlevels = x.result;
          if(this.memberlevels.length==0){
            this.$toast.fail('您当前等级无法发展下级');
            this.$router.go(-1);
          }
        });
       
    } else {
      this.ztitle="推荐代理";
      this.ajax
        .post("/api/services/app/PhoneUser/QueryMyRefMember")
        .then((x) => {
          this.memberlevels = x.result;
        });
        
    }
  },
  methods: { 
    generate() {
      let level = this.memberlevels.filter(
        (x) => x.id == this.selectLevelId
      )[0];
      this.$router.push({
        path: "/mynvitationqrcode",
        query: {
          levelId: this.selectLevelId,
          levelname: level.name,
          registMethod: this.registMethod,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>

    .group-main{
        background-color: #fff;
        position: relative;
        padding: 20px;
        margin: 10px;
        box-shadow: 1px 1px 4px #b9b9b9;
        border-radius: 8px;
        font-size: 16px;
        border-radius: 8px;
    }
   
    .group-main-conf{
        position: relative;
        padding-left:80px;
        padding-right: 80px;
    }

    .group-main-conf-pic
    {
      position: absolute;
      width: 70px;
      height: 70px;
      left:0;
      top:50%;
      transform: translate(0,-50%);
    }
    .group-main-conf-pic img{
      width: 100%;
      height: 100%;
    }
    .group-main-conf-radio
    {
        position: absolute;
        right:0;
        top:50%;
        transform: translate(0,-50%);
    }


</style>